import API from 'utils/api';
import getFormattedValues, { formatReceived, hasFiles } from 'utils/formatValues';
import { onSuccess, onError } from 'utils/handlers';

export const baseURI = '/recaudacion/pagos-externos/';
const files = ['archivo'];

/**
 * GET Pagos Externos
 * @returns {Promise<Array<object>>}
 */
export const getPagosExternos = async (params = null) => {
  try {
    const response = await API.get(baseURI, { params });
    return formatReceived(response.data);
    // results: formatReceived(response.data?.results),
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * GET Pago Externo
 * @returns {Promise<Array<object>>}
 */
export const getPagoExterno = async (id) => {
  try {
    const response = await API.get(`${baseURI}${id}`);
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * POST Pago Externo
  * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const procesarPago = async (values) => {
  try {
    const config = hasFiles(values, files) ? {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    } : {};
    const formattedValues = getFormattedValues(values, {
      files,
      formData: config.headers,
      clean: false,
    });
    const response = await API.post(`${baseURI}procesar`, formattedValues, config);
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return false;
  }
};
/**
 * POST Consultar registros del archivo previos a procesar
  * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const consultarRegistros = async (values) => {
  try {
    const config = hasFiles(values, files) ? {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    } : {};
    const formattedValues = getFormattedValues(values, {
      files,
      formData: config.headers,
      clean: false,
    });
    const response = await API.post(`${baseURI}consultar`, formattedValues, config);
    onSuccess(response, 'Agregado correctamente');
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return false;
  }
};
